import { render } from "./VideoCategoryList.vue?vue&type=template&id=1add150f&ts=true"
import script from "./VideoCategoryList.vue?vue&type=script&lang=ts"
export * from "./VideoCategoryList.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/eiji/workspace/tradelabo/members.tradelabo.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__